import actions from '../../../constants/actionTypes';
import { getDate } from '../../../utils/utils';
import { COMMON_CONST } from '../../../constants/constants';
import { EnumPage } from '../../../constants/enum';
import {
  handleChangeFilters,
  handleChangeTableActivePage,
  handleChangeTablePageSize,
} from '../../../redux/genericReducerHandler';

const initialState = {
  filters: {
    fromDate: getDate(-1),
    toDate: getDate(),
    transactionType: null,
    status: null,
    store: null,
  },
  table: {
    itemList: [],
    totalSize: 0,
    activePage: 1,
    pageSize: COMMON_CONST.PageSize,
  },
  dialog: {
    isOpenDialog: false,
    itemId: 0,
  },
  stores: null,
  storeMapping: {},
  metadata: null,
  profile: {},
};

function walletTransactionHistoryReducer(state = initialState, action) {
  const PAGE = EnumPage.NOW_PORTAL_TRANSACTION_HISTORY.id;
  const { response, type } = action;
  switch (type) {
    case actions.CHANGE_TABLE_PAGE_SIZE: {
      return handleChangeTablePageSize(PAGE, state, action);
    }
    case actions.CHANGE_TABLE_ACTIVE_PAGE: {
      return handleChangeTableActivePage(PAGE, state, action);
    }
    case actions.CHANGE_FILTER_GENERIC: {
      return handleChangeFilters(PAGE, state, action, initialState);
    }
    case actions.RECEIVE_PROFILE_NOW_PORTAL: {
      const { profile } = response;
      return {
        ...state,
        profile,
      };
    }
    case actions.RECEIVE_ORDER_MANAGEMENT_LIST_NOW_PORTAL: {
      const { itemList, totalSize } = response;
      return {
        ...state,
        table: {
          ...state.table,
          itemList,
          totalSize,
        },
      };
    }
    case actions.RECEIVE_LIST_STORE_NOW_PORTAL: {
      const { stores } = response;

      return {
        ...state,
        stores,
        storeMapping: stores.reduce(
          (result, store) => ({
            ...result,
            [store.ref]: store,
          }),
          {},
        ),
      };
    }
    default:
      return state;
  }
}

export default walletTransactionHistoryReducer;



// WEBPACK FOOTER //
// ./foody/src/pages/NowPortal/NowPortalOrder/reducers.js